import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLeafStreamlineSolar = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.375 1.735a3 3 0 0 0-.594.203c-3.32 1.552-5.448 5.89-5.448 9.61 0 3.532 2.653 6.435 6.042 6.756zM10.625 18.304c3.389-.32 6.042-3.223 6.042-6.757q0-.508-.053-1.027l-5.989 5.989zM15.216 5.983a11 11 0 0 0-1.116-1.7L10.625 7.76v2.815zM13.257 3.359a7.6 7.6 0 0 0-2.038-1.421 3 3 0 0 0-.594-.203v4.256zM15.78 7.187l-5.155 5.155v2.4l5.625-5.626.11-.11a12.5 12.5 0 0 0-.58-1.819"
      />
    </svg>
  );
};
export default SvgLeafStreamlineSolar;
